import React from 'react'
import olaplexBenefitsBanner from "./../../../../../Images/Blog/10 Amazing Benefits of Olaplex Hair Treatment/Banner.png";

const TenOlaplexBenefitsImg = () => {
  return (
    <div className="blogImg-content">
      <img src={olaplexBenefitsBanner} alt="olaplex Benefits Banner" loading="lazy" />
    </div>
  )
}

export default TenOlaplexBenefitsImg
